import React, { Component } from 'react'
import get from 'lodash/get'
import UniversityPage from './university'

export default class UniversityEU extends Component {
  render() {
    const data = get(this, 'props.data.contentfulPartnerUniversityEu')
    return <UniversityPage data={data} />
  }
}

export const euUniversityQuery = graphql`
  query euUniversityQuery($name: String!) {
    contentfulPartnerUniversityEu(name: { eq: $name }) {
      name
      link
      longText {
        internal {
          content
        }
      }
      generalInformationAddress
      coordinatorAddress
      image {
        sizes(maxWidth: 150) {
          src
        }
      }
      photo {
        sizes(maxWidth: 1280) {
          ...GatsbyContentfulSizes
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/universityEU.js